import { LiveStreamDestination, LiveStreamStatus } from 'types/stream';

export type GetDestinationUrlProps = Pick<LiveStreamDestination, 'response' | 'network'> & {
  streamStatus: LiveStreamStatus | null;
};

const getDestinationUrl = ({ network, streamStatus, response }: GetDestinationUrlProps) => {
  const { live_link, studio_link } = response;
  switch (network) {
    case 'YOUTUBE':
    case 'LINKEDIN': {
      return live_link;
    }
    case 'FACEBOOK':
    case 'TWITCH': {
      return streamStatus === 'SCHEDULED' ? studio_link : live_link;
    }
  }
};

export default getDestinationUrl;
